<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Tipos de Solicitud</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Tipos_Solicitud_PTI</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label>Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre del tipo de solicitud"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerTiposSolicitud"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button v-b-tooltip.hover title="Crear menú" variant="outline-success"
                        @click="agregar()"
              >Crear Tipo Solicitud
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Modificar Tipo de Solicitud"
                    size="sm"
                    variant="outline-warning"
                    @click="modificar(row.item)"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button
                          v-if="!row.item.registroActivo"
                          title="Activar tipo solicitud"
                          variant="outline-success"
                          size="sm"
                          @click="activarDesactivarTipoSolicitud(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else
                          title="Desactivar tipo solicitud"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivarTipoSolicitud(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>


    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
    >
      <b-container fluid>
        <b-row>
          <b-col>
            <b-form>
              <b-form-group align="left">
                <label>Nombre del Tipo de Solicitud
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="descripcion" name="descripcion" placeholder="Nombre del tipo de solicitud"
                                v-model="$v.tipoSolicitud.descripcion.$model"
                                :state="validateState('descripcion')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
              <b-form-group align="left">
                <label>Nivel de Servicio (Días)
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input id="nivel" name="nivel" placeholder="Nivel de servicio"
                                v-model="tipoSolicitud.nivelServicio" type="number"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </div>
    </b-modal>
  </div>

</template>

<script>
import Header from "@/components/Header";
import {required} from "vuelidate/lib/validators";
export default {
  name: "tipoSolicitud",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        { key: "idTipoSolicitud", label: "ID", sortable: true },
        { key: "descripcion", label: "Nombre", sortable: true },
        { key: "nivelServicio", label: "Nivel de servicio", sortable: true },
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
      tituloModal: '',
      loaderAcciones: false,
      show: false,
      tipoSolicitud: {
        idTipoSolicitud: null,
        descripcion: null,
        nivelServicio: null,
        registro: null,
      },
      loader: false,
      listaEstatusM2:[]
    }
  },
  validations: {
    tipoSolicitud: {
      descripcion:{required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerTiposSolicitud();
  },
  methods: {
    obtenerTiposSolicitud() {
      this.loader = true;
      this.$http
          .post(this.$api + "catalogos/obtenerTiposSolicitud", this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    agregar() {
      this.tipoSolicitud = {
        idTipoSolicitud: null,
        descripcion: null,
        nivelServicio: null,
        registro: null,
      };
      this.tituloModal = 'Agregar Tipo Solicitud';
      this.show = true;
    },
    cerrarModal() {
      this.showDetalle = false;
      this.show = false;
    },
    guardar(){
      this.$v.tipoSolicitud.$touch();
      if (this.$v.tipoSolicitud.$anyError) {
        return;
      }
      if (!this.$v.tipoSolicitud.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'catalogos/guardarTipoSolicitud', this.tipoSolicitud).then(respuesta => {
              if (respuesta.data.data) {
                this.filtro = {
                  id: null,
                  palabraClave: null,
                  registroActivo: null
                };
                this.obtenerTiposSolicitud();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El tipo de solicitud se guardó correctamente",
                });
              }
            }
        ).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
    modificar(item) {
      this.tipoSolicitud = item;
      this.tituloModal = 'Modificar Tipo Solicitud';
      this.show = true;
    },
    activarDesactivarTipoSolicitud(item){
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar el tipo de solicitud?' : '¿Está seguro de activar el tipo de solicitud?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            id: item.idTipoSolicitud,
          }
          this.$http.post(this.$api + 'catalogos/desactivarActivarTipoSolicitud', parametros).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El tipo de solicitud se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.tipoSolicitud[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>

</style>
